export default __webpack_public_path__ + "a38d128733b19bda9b1a6dca593e3b7a.png";